/* Lollenstein Auswahl-Extras (Vorwahl, Laborwert-Regler, Such-Finder)
   1) Auswahlseiten (Heu/Heulage): URL-Parameter vom Such-Hub
      - ?eignung=<key>  -> klickt den passenden Eignungsfilter der Uebersicht
      - ?merkmal=<key>  -> blendet Sortenkarten aus, deren Charge nicht passt
      - ?laborwerte=1   -> oeffnet das Laborwerte-Panel und scrollt dorthin
      plus aufklappbares Panel mit Min-Max-Schiebereglern (Zucker, Fruktan,
      Energie) ueber die data-compare-* Attribute der Karten.
   2) Suchseite (Sektion ll-such-hub): EIN Finder ueber EINER gemischten
      Sortenliste (Heu + Heulage). Futterart-Schalter, Eignungs-Select,
      Merkmal-Chips und Laborwert-Regler filtern die Liste [data-llhub-item]
      gemeinsam; ohne aktiven Filter ist die Liste auf wenige Karten gekuerzt.
   Original-Dateien bleiben unveraendert. */
(function () {
  "use strict";
  if (window.LollensteinAuswahlVorwahlInit) return;
  window.LollensteinAuswahlVorwahlInit = true;

  var TESTS = {
    fein: ["data-compare-structure", "fein"],
    mittel: ["data-compare-structure", "mittel"],
    grob: ["data-compare-structure", "grob"],
    trocken: ["data-compare-moisture", "trocken"],
    feucht: ["data-compare-moisture", "feucht"],
    schnitt1: ["data-compare-cut", "1."],
    schnitt2: ["data-compare-cut", "2."]
  };

  var METRICS = [
    { key: "sugar", colAttr: "data-compare-sugar", hubAttr: "data-sugar", label: "Gesamtzucker", unit: "% TS" },
    { key: "fructan", colAttr: "data-compare-fructan", hubAttr: "data-fructan", label: "Fruktan", unit: "% TS" },
    { key: "energy", colAttr: "data-compare-energy", hubAttr: "data-energy", label: "Energie", unit: "MJ/kg TS" }
  ];

  var INITIAL_LIMIT = 6;

  function attrContains(card, attr, needle) {
    var value = card.getAttribute(attr) || "";
    return value.toLowerCase().indexOf(needle) !== -1;
  }

  function formatNumber(value) {
    return String(Math.round(value * 10) / 10).replace(".", ",");
  }

  function metricValue(card, metric, attrField) {
    return parseFloat(card.getAttribute(metric[attrField]) || "");
  }

  /* ---------- Vorwahl auf den Auswahlseiten ---------- */

  function showAllCards() {
    var hidden = document.querySelectorAll("[data-ls-merkmal-hidden]");
    for (var i = 0; i < hidden.length; i++) {
      hidden[i].hidden = false;
      hidden[i].removeAttribute("data-ls-merkmal-hidden");
    }
  }

  function applyMerkmal(key) {
    var test = TESTS[key];
    if (!test) return false;
    var cards = document.querySelectorAll("[data-heu-card]");
    if (!cards.length) return false;
    for (var i = 0; i < cards.length; i++) {
      if (!attrContains(cards[i], test[0], test[1])) {
        cards[i].hidden = true;
        cards[i].setAttribute("data-ls-merkmal-hidden", "1");
      }
    }
    var filters = document.querySelectorAll(".llh__filter");
    for (var j = 0; j < filters.length; j++) {
      filters[j].addEventListener("click", showAllCards, { once: true });
    }
    return true;
  }

  function applyEignung(key) {
    var selector = '.llh__filter[data-heu-filter="' + key.replace(/["\\]/g, "") + '"]';
    var button = document.querySelector(selector);
    if (!button) return false;
    if (button.classList.contains("is-active")) return true;
    button.click();
    return button.classList.contains("is-active");
  }

  function scrollToFinder() {
    var target = document.querySelector(".llh__finder") || document.querySelector(".llh__products");
    if (target) target.scrollIntoView({ behavior: "auto", block: "start" });
  }

  /* ---------- Schieberegler-Bausteine ---------- */

  function buildLabRow(metric, bounds, body, onChange) {
    var row = document.createElement("div");
    row.className = "llh-lab__row";
    var head = document.createElement("div");
    head.className = "llh-lab__row-head";
    var title = document.createElement("strong");
    title.textContent = metric.label;
    var readout = document.createElement("span");
    head.appendChild(title);
    head.appendChild(readout);
    row.appendChild(head);

    var range = document.createElement("div");
    range.className = "llh-lab__range";
    var track = document.createElement("div");
    track.className = "llh-lab__track";
    var fill = document.createElement("div");
    fill.className = "llh-lab__fill";
    range.appendChild(track);
    range.appendChild(fill);

    var state = { bounds: bounds, lo: bounds.min, hi: bounds.max };

    function makeInput(value) {
      var input = document.createElement("input");
      input.type = "range";
      input.min = String(bounds.min);
      input.max = String(bounds.max);
      input.step = "0.1";
      input.value = String(value);
      range.appendChild(input);
      return input;
    }
    state.inputLo = makeInput(bounds.min);
    state.inputHi = makeInput(bounds.max);
    state.inputLo.setAttribute("aria-label", metric.label + " Minimum in " + metric.unit);
    state.inputHi.setAttribute("aria-label", metric.label + " Maximum in " + metric.unit);

    state.update = function () {
      var span = bounds.max - bounds.min;
      var loPct = span > 0 ? ((state.lo - bounds.min) / span) * 100 : 0;
      var hiPct = span > 0 ? ((state.hi - bounds.min) / span) * 100 : 100;
      fill.style.left = loPct + "%";
      fill.style.width = Math.max(0, hiPct - loPct) + "%";
      readout.textContent = formatNumber(state.lo) + " \u2013 " + formatNumber(state.hi) + " " + metric.unit;
    };

    function onInput() {
      var lo = parseFloat(state.inputLo.value);
      var hi = parseFloat(state.inputHi.value);
      if (lo > hi) {
        var swap = lo;
        lo = hi;
        hi = swap;
      }
      state.lo = lo;
      state.hi = hi;
      state.update();
      onChange();
    }
    state.inputLo.addEventListener("input", onInput);
    state.inputHi.addEventListener("input", onInput);

    state.update();
    row.appendChild(range);
    body.appendChild(row);
    return state;
  }

  /* Reglerzeilen fuer alle Metriken mit Wertespanne; null wenn keine. */
  function makeSliderSet(host, items, attrField, onChange) {
    var rows = {};
    var hasAny = false;
    for (var m = 0; m < METRICS.length; m++) {
      var metric = METRICS[m];
      var min = Infinity;
      var max = -Infinity;
      var count = 0;
      for (var i = 0; i < items.length; i++) {
        var value = metricValue(items[i], metric, attrField);
        if (isNaN(value)) continue;
        count++;
        if (value < min) min = value;
        if (value > max) max = value;
      }
      if (count >= 2 && max > min) {
        var bounds = { min: Math.floor(min * 10) / 10, max: Math.ceil(max * 10) / 10 };
        rows[metric.key] = buildLabRow(metric, bounds, host, onChange);
        hasAny = true;
      }
    }
    if (!hasAny) return null;

    return {
      activeRanges: function () {
        var active = [];
        for (var m = 0; m < METRICS.length; m++) {
          var row = rows[METRICS[m].key];
          if (!row) continue;
          if (row.lo > row.bounds.min + 0.001 || row.hi < row.bounds.max - 0.001) {
            active.push({ metric: METRICS[m], lo: row.lo, hi: row.hi });
          }
        }
        return active;
      },
      reset: function () {
        for (var m = 0; m < METRICS.length; m++) {
          var row = rows[METRICS[m].key];
          if (!row) continue;
          row.lo = row.bounds.min;
          row.hi = row.bounds.max;
          row.inputLo.value = String(row.bounds.min);
          row.inputHi.value = String(row.bounds.max);
          row.update();
        }
      }
    };
  }

  /* ---------- Panel auf den Auswahlseiten (Heu/Heulage) ---------- */

  function buildCollectionLab(openPanel) {
    var finder = document.querySelector(".llh__finder");
    if (!finder) return true;
    if (document.querySelector(".llh-lab")) return true;
    var host = document.querySelector(".llh__finder .llh__wrap") || finder;
    var cards = document.querySelectorAll("[data-heu-card]");
    if (!cards.length) return false;

    var panel = document.createElement("details");
    panel.className = "llh-lab";
    var summary = document.createElement("summary");
    summary.textContent = "Nach Laborwerten filtern";
    panel.appendChild(summary);
    var body = document.createElement("div");
    body.className = "llh-lab__body";
    panel.appendChild(body);

    var status = document.createElement("p");
    status.className = "llh-lab__status";
    var reset = document.createElement("button");
    reset.type = "button";
    reset.className = "llh-lab__reset";
    reset.textContent = "Zur\u00fccksetzen";
    reset.hidden = true;

    function apply() {
      var ranges = set.activeRanges();
      var all = document.querySelectorAll("[data-heu-card]");
      var visible = 0;
      var missing = 0;
      for (var i = 0; i < all.length; i++) {
        var card = all[i];
        var pass = true;
        var noValue = false;
        for (var a = 0; a < ranges.length; a++) {
          var value = metricValue(card, ranges[a].metric, "colAttr");
          if (isNaN(value)) { pass = false; noValue = true; break; }
          if (value < ranges[a].lo - 0.001 || value > ranges[a].hi + 0.001) { pass = false; break; }
        }
        if (pass) {
          visible++;
          card.removeAttribute("data-ls-lab-hidden");
        } else {
          if (noValue) missing++;
          card.setAttribute("data-ls-lab-hidden", "1");
        }
      }
      var text = "";
      if (ranges.length) {
        text = visible + " von " + all.length + " Sorten im Bereich";
        if (missing > 0) text += " \u00b7 " + missing + " ohne Laboranalyse ausgeblendet";
      }
      status.textContent = text;
      reset.hidden = !ranges.length;
    }

    var set = makeSliderSet(body, cards, "colAttr", apply);
    if (!set) return true;

    reset.addEventListener("click", function () {
      set.reset();
      apply();
    });
    var foot = document.createElement("div");
    foot.className = "llh-lab__foot";
    foot.appendChild(status);
    foot.appendChild(reset);
    body.appendChild(foot);

    host.appendChild(panel);
    if (openPanel) {
      panel.open = true;
      window.setTimeout(function () {
        panel.scrollIntoView({ behavior: "auto", block: "start" });
      }, 60);
    }
    return true;
  }

  /* ---------- Finder auf der Suchseite ---------- */

  function buildHubFinder(openLab) {
    var finder = document.querySelector("[data-llhub-finder]");
    if (!finder) return true;
    if (finder.getAttribute("data-ls-done")) return true;
    var items = document.querySelectorAll("[data-llhub-item]");
    if (!items.length) return true;
    finder.setAttribute("data-ls-done", "1");

    var typeButtons = finder.querySelectorAll("[data-llhub-type]");
    var eignungSelect = finder.querySelector("[data-llhub-eignung]");
    var traitButtons = finder.querySelectorAll("[data-llhub-trait]");
    var labDetails = finder.querySelector("[data-llhub-lab-details]");
    var labHost = finder.querySelector("[data-llhub-lab]");
    var status = document.querySelector("[data-llhub-status]");
    var reset = document.querySelector("[data-llhub-reset]");
    var more = document.querySelector("[data-llhub-more]");

    var state = { type: "alle", eignung: "", traits: {}, expanded: false };

    function anyFilter(ranges) {
      if (state.type !== "alle" || state.eignung) return true;
      for (var key in state.traits) {
        if (state.traits[key]) return true;
      }
      return ranges.length > 0;
    }

    function apply() {
      var ranges = sliderSet ? sliderSet.activeRanges() : [];
      var filtering = anyFilter(ranges);
      var total = items.length;
      var matched = 0;
      var missing = 0;
      for (var i = 0; i < total; i++) {
        var item = items[i];
        var ok = true;
        var noValue = false;
        if (state.type !== "alle" && item.getAttribute("data-futterart") !== state.type) ok = false;
        if (ok && state.eignung) {
          var keys = item.getAttribute("data-eignungen") || "";
          if (keys.indexOf("|" + state.eignung + "|") === -1) ok = false;
        }
        if (ok) {
          for (var t in state.traits) {
            if (!state.traits[t]) continue;
            var traits = item.getAttribute("data-traits") || "";
            if (traits.indexOf("|" + t + "|") === -1) { ok = false; break; }
          }
        }
        if (ok) {
          for (var a = 0; a < ranges.length; a++) {
            var value = metricValue(item, ranges[a].metric, "hubAttr");
            if (isNaN(value)) { ok = false; noValue = true; break; }
            if (value < ranges[a].lo - 0.001 || value > ranges[a].hi + 0.001) { ok = false; break; }
          }
        }
        var show = false;
        if (ok) {
          matched++;
          show = filtering || state.expanded || matched <= INITIAL_LIMIT;
        } else if (noValue) {
          missing++;
        }
        if (show) item.removeAttribute("data-ls-lab-hidden");
        else item.setAttribute("data-ls-lab-hidden", "1");
      }

      if (status) {
        var text;
        if (filtering) {
          text = matched + " von " + total + " Sorten passen";
          if (missing > 0) text += " \u00b7 " + missing + " ohne Laboranalyse ausgeblendet";
        } else {
          text = total + " Sorten lieferbar";
        }
        status.textContent = text;
      }
      if (reset) reset.hidden = !filtering;
      if (more) {
        var hiddenRest = !filtering && !state.expanded && matched > INITIAL_LIMIT;
        more.hidden = !hiddenRest;
        if (hiddenRest) more.textContent = "Alle " + matched + " Sorten anzeigen";
      }
    }

    var sliderSet = labHost ? makeSliderSet(labHost, items, "hubAttr", apply) : null;
    if (!sliderSet && labDetails) labDetails.hidden = true;

    for (var b = 0; b < typeButtons.length; b++) {
      typeButtons[b].addEventListener("click", function () {
        state.type = this.getAttribute("data-llhub-type") || "alle";
        for (var x = 0; x < typeButtons.length; x++) {
          typeButtons[x].classList.toggle("is-active", typeButtons[x] === this);
        }
        apply();
      });
    }
    if (eignungSelect) {
      eignungSelect.addEventListener("change", function () {
        state.eignung = eignungSelect.value || "";
        apply();
      });
    }
    for (var c = 0; c < traitButtons.length; c++) {
      traitButtons[c].addEventListener("click", function () {
        var key = this.getAttribute("data-llhub-trait");
        state.traits[key] = !state.traits[key];
        this.classList.toggle("is-active", state.traits[key]);
        apply();
      });
    }
    if (more) {
      more.addEventListener("click", function () {
        state.expanded = true;
        apply();
      });
    }
    if (reset) {
      reset.addEventListener("click", function () {
        state.type = "alle";
        state.eignung = "";
        state.traits = {};
        for (var x = 0; x < typeButtons.length; x++) {
          typeButtons[x].classList.toggle("is-active", typeButtons[x].getAttribute("data-llhub-type") === "alle");
        }
        if (eignungSelect) eignungSelect.value = "";
        for (var y = 0; y < traitButtons.length; y++) {
          traitButtons[y].classList.remove("is-active");
        }
        if (sliderSet) sliderSet.reset();
        apply();
      });
    }

    if (openLab && labDetails && sliderSet) labDetails.open = true;
    apply();
    return true;
  }

  /* ---------- Start ---------- */

  function run() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      params = null;
    }
    var eignung = params ? params.get("eignung") : null;
    var merkmal = params ? params.get("merkmal") : null;
    var openLab = params ? params.get("laborwerte") === "1" : false;

    var attempts = 0;
    var tryApply = function () {
      attempts += 1;
      var done = true;
      if (!buildCollectionLab(openLab)) done = false;
      if (!buildHubFinder(openLab)) done = false;
      if (eignung && !applyEignung(eignung)) done = false;
      if (merkmal && !applyMerkmal(merkmal)) done = false;
      if (done) {
        if ((eignung || merkmal) && !openLab) window.setTimeout(scrollToFinder, 60);
      } else if (attempts < 25) {
        window.setTimeout(tryApply, 160);
      }
    };
    tryApply();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
